import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import SectionLabel from "@/components/SectionLabel";

export default function ComingSoon() {
  return (
    <div data-testid="coming-soon-page" className="bg-[#050505] text-[#F3E8E0] min-h-screen">
      <section className="relative pt-32 pb-24 md:pt-44 md:pb-32 overflow-hidden grain-bg min-h-[80vh] flex items-center">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#FF4A00] opacity-[0.08] rounded-full blur-[180px] pointer-events-none" />

        <div className="max-w-3xl mx-auto px-6 md:px-10 relative text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <SectionLabel className="justify-center inline-block mb-6">Coming soon</SectionLabel>
            <h1
              data-testid="coming-soon-title"
              className="font-display text-4xl md:text-6xl lg:text-7xl font-semibold tracking-tighter leading-[0.92]"
            >
              We&rsquo;re building something{" "}
              <span className="italic text-[#FF4A00] font-medium">powerful.</span>
            </h1>
            <p className="mt-8 text-lg md:text-xl text-[#A3A3A3] leading-relaxed max-w-xl mx-auto">
              Sign-up and onboarding are launching shortly. Reach out if you&rsquo;d like early access or
              want to discuss a campaign in the meantime.
            </p>

            <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/contact"
                data-testid="coming-soon-contact"
                className="inline-flex items-center gap-2 bg-[#FF4A00] text-white text-base font-medium px-7 py-4 rounded-full hover:bg-[#E64300] transition-all active:scale-95"
              >
                <Mail className="w-5 h-5" /> Contact our team
              </Link>
              <Link
                to="/"
                data-testid="coming-soon-home"
                className="inline-flex items-center gap-2 border border-[#333] text-[#F3E8E0] text-base font-medium px-7 py-4 rounded-full hover:border-[#FF4A00] hover:text-[#FF4A00] transition-colors"
              >
                <ArrowLeft className="w-5 h-5" /> Back to home
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
